import { Deserializable } from '../../../../protocols/deserializable';
import { Address } from '../../../../users/dto/address';

export class EmployerContactSubmissionData implements Deserializable {
  public id!: string;
  public employerContactId!: number | null;
  public firstName!: string;
  public lastName!: string;
  public jobTitle!: string;
  public email!: string;
  public phoneNumberCountryCode!: string;
  public phoneNumber!: string;
  public contactTopic!: string | null;
  public hasSigningAuthority!: boolean;
  public primaryContact!: boolean;
  public address!: Address | null;

  public onDeserialize() {
    if (this.address) {
      this.address = window.injector.Deserialize.instanceOf(Address, this.address);
    }
  }
}
